import _ from 'lodash';
import React, {Component} from 'react';
import {
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
  Card,
  CardTitle,
  CardText,
  LinearProgress,
  TablePagination,
  Grid,
  Cell, Button
} from 'react-md';
import moment from 'moment';

//import loanService from './../../../services/loan';
import { baseUrl } from './../../../services/endpoints';

import DefaultLayout from './../../../components/layouts/default';
import PieChart from './../../../components/molecules/charts/pieChart';
import TableActions from './../../../components/molecules/tableActions';
import ReportsNav from './../../../components/atoms/subNavs/reportsNav';
//  import {AxiosInstance as axios} from "axios";
import {optionsGET} from "../../../services/options";
import FlatOrIconButton from "../../../components/atoms/flatOrIconButton";
import Workbook from "react-excel-workbook";

class DeviceReport extends Component {
  handlePagination(start, rowsPerPage) {
    this.setState({
      slicedData: this.state.data.slice(start, start + rowsPerPage)
    });
  };

  constructor(props) {
    super(props);

    this.state = {
      excelData: null,
      data: null,
      loading: false,
      operation: '',
      slicedData: null,
      devices: {
        data: null,
        loading: false,
        total: '0',
      },
    };

    this.getData = this.getData.bind(this);
    this.handlePagination = this.handlePagination.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    this.setState({
      loading: true,
      data: [],
      slicedData: [],
      devices: {
        loading: true
      }
    });
    /*
    let params = {
      operation: 'SIP2 USER VALIDATE',
      limit: 500
    };
    if (this.state.operation !== '') {
      params = {...params, operation: this.state.operation};
    }
    */

    //  return loanService.userTraces('devices')

    function formatDate(date) {
      const startWithYear = /^[0-9]{4}/.test(date);
      const newDate = startWithYear ? date.slice(0, 10).split('-') : date.slice(0, 10).split('/');
      const hour = date.slice(11,);
      const day = startWithYear ? newDate[2] : newDate[0];
      const month = newDate[1];
      const year = startWithYear ? newDate[0] : newDate[2];

      //  console.log(date)
      //  console.log(`${day}-${month}-${year} / ${hour}`)

      return `${day}/${month}/${year} ${hour}`;
    }

    //return fetch('http://52.14.65.118:4000/user_traces/devices', optionsGET())
    return fetch(baseUrl + 'user_traces/devices', optionsGET())
      .then(response => response.json())
      .then(response => {
        console.log(response);
        const excelData = response
        //  .filter(({result}) => !/error/ig.test(result))
          .map(({so, device, username}) =>
            ({
              username,
              device: (so || device) ? `${so ? so : ' '}${device ? device : ''}` : 'Sin información'
            }));
        const data = response.map(element => {
          let ref = {
            'Usuario': '',
            'Dispositivo': '',
            //  'Operación': '',
            //  'Código de barras': '',
            //  'Resultado': '',
            //  'Información': '',
            //  'Fecha': ''
          };

          if (element.username) ref['Usuario'] = element.username;
          if (element.so) ref['Dispositivo'] = (element.so || element.device) ? `${element.so ? element.so : ' '}${element.device ? element.device : ''}` : 'Sin información';
          if (element.operation) ref['Operación'] = element.operation;
          if (element.result) ref['Resultado'] = element.result;
          if (element.data) ref['Información'] = element.data;
          if (element.inserted_at) ref['Fecha'] = formatDate(element.inserted_at);

          return ref;
        });

        const devices = response
          .map(item => ({name: item.so || 'Desconocido'}))
          .reduce((arr, item) => {
            let found = false;

            for (let i = 0; i < arr.length; i++) {
              if (arr[i].name === item.name) {
                found = true;
                arr[i].count++;
              }
            }

            if (!found) {
              item.count = 1;
              arr.push(item);
            }

            return arr;
          }, []);

        this.setState({
          ...this.state,
          excelData,
          data,
          slicedData: data.slice(0, 10),
          loading: false,
          devices: {
            loading: false,
            data: devices,
            total: devices.reduce((total, element) => {
              return total + element.count;
            }, 0),
          },
        });
      });
  }

  render() {
    let devices = {};
    let total = 0;
    let data = [];

    if (this.state.devices) devices = this.state.devices;
    if (this.state.devices.data) data = this.state.devices.data;
    if (this.state.devices.total) total = this.state.devices.total;

    console.log(this.state.devices.data);

    return (
      <DefaultLayout>
        <Grid>
          <Cell size={12}>
            <ReportsNav />
          </Cell>
          <Cell size={12}>
            <Card style={styles.card}>
              <CardTitle title={total} subtitle='Dispositivos' />
              <CardText>
                {devices.loading && (<LinearProgress id='devicesProgress' />)}

                {data && (
                  <Grid>
                    <Cell size={12}>
                      <PieChart
                        width={400}
                        height={220}
                        data={this.state.devices.data}
                        dataKey='count'
                      />
                    </Cell>

                    {/*
                    <Cell size={6}>
                      <SelectField
                        id='operation'
                        label="Operación"
                        placeholder="Seleccione para filtrar"
                        className="md-cell md-cell--bottom"
                        menuItems={[
                          {label: 'Todas', value: ''},
                          {label: 'SIP2 COPIES REPORT', value: 'SIP2 COPIES REPORT'},
                          {label: 'USER VALIDATE', value: 'USER VALIDATE'},
                          {label: 'WEB GENERAL LOAN REPORT', value: 'WEB GENERAL LOAN REPORT'},
                          {label: 'LOAN', value: 'LOAN'},
                        ]}
                        value={this.state.operation}
                        onChange={(value) => {
                          this.setState({operation: value});
                          this.getData();
                        }}
                      />
                      <List>
                        {this.state.devices.data.map((element, i) => (
                          <ListItem
                            key={i}
                            primaryText={element.name}
                            secondaryText={`${element.count} dispositivos`}
                            leftIcon={<FontIcon key="data">phone_iphone</FontIcon>}
                          />
                        ))}
                      </List>
                    </Cell>
                    */}
                  </Grid>
                )}

              </CardText>
            </Card>
            <Card tableCard>
              <TableActions title='Prestamos por Dispositivos' count={0} onResetClick={this.getData} />
              <Workbook
                filename='Prestamos por Dispositivos.xlsx'
                element={!this.state.loading
                  ? <Button
                    style={{marginLeft: 20}}
                    raised
                    primary
                    iconEl={<FlatOrIconButton
                      iconChildren='folder'
                      style={{color: '#fff'}}>»Exportar</FlatOrIconButton>} />
                  : <Button
                    style={{marginLeft: 20}}
                    raised
                    primary
                    iconEl={<FlatOrIconButton
                      iconChildren='folder'
                      style={{color: '#fff'}}>Cargando...</FlatOrIconButton>} />
                }>

                <Workbook.Sheet
                  data={this.state.excelData}
                  name='Reportes'>
                  <Workbook.Column
                    label='Usuario'
                    value='username' />
                  <Workbook.Column
                    label='Dispistivo'
                    value='device' />
                </Workbook.Sheet>
              </Workbook>
              {this.state.loading && <LinearProgress id='usersProgress' />}
              <DataTable baseId='dynamic-content-desserts'>
                {!this.state.data && (
                  <tbody>
                    <tr>
                      <td style={{textAlign: 'center', padding: '10px'}}>Sin Registro</td>
                    </tr>
                  </tbody>
                )}
                {this.state.slicedData && (
                  <React.Fragment>
                    <TableHeader>
                      <TableRow>
                        {this.state.slicedData.length > 0 && Object.keys(this.state.slicedData[0]).map((header, i) => (
                          <TableColumn key={header}>{header}</TableColumn>
                        ))}
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {this.state.slicedData.map((item, i) => (
                        <TableRow key={`item_table${i}`}>
                          {Object.keys(item).map(key => (
                            <TableColumn key={key}>{item[key]}</TableColumn>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                    <TablePagination
                      rows={this.state.data.length}
                      rowsPerPageLabel='Registros por página'
                      onPagination={this.handlePagination}
                    />
                  </React.Fragment>
                )}
              </DataTable>
            </Card>
          </Cell>
        </Grid>
      </DefaultLayout>
    );
  }
}

const styles = {
  card: {
    borderRadius: '2px',
    marginBottom: '2rem',
  },
};


export default DeviceReport;



// WEBPACK FOOTER //
// ./src/pages/home/reports/devices.js